/**
 * Remove OAuth redirect parameters from the URL
 *
 * After successful authentication, OAuth parameters are no longer needed
 * and can cause issues on page refresh (attempting to redeem the same code).
 *
 * This function removes all OAuth-related parameters from the URL without
 * reloading the page, using window.history.replaceState().
 */
export function cleanOAuthParamsFromUrl(): void {
  const url = new URL(window.location.href);

  // Remove OAuth-specific parameters
  url.searchParams.delete('code');
  url.searchParams.delete('state');
  url.searchParams.delete('session_state');
  url.searchParams.delete('error');
  url.searchParams.delete('error_description');

  // Replace the URL without reloading the page
  window.history.replaceState({}, document.title, url.toString());
}
